"use strict";
var group_detail_controller_1 = require("./group-detail.controller");
var templateUrl = require("./group-detail.html");
exports.groupDetail = {
    templateUrl: templateUrl,
    controller: group_detail_controller_1.GroupDetailController,
    controllerAs: "vm",
    bindings: {}
};



/** WEBPACK FOOTER **
 ** ./app/group-detail/group-detail.ts
 **/